import { z } from 'zod'

import { m } from '@maestro/commerce-blocks/schemas/helpers'

export const changeEmailConfirmationFormSchema = z.object({
  email: z.string(),
  password: z.string().nonempty(m('password.required')).max(100),
})
